import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  mainURL = 'api/payment/';
  baseURL = environment.baseURL
  constructor(private http: HttpClient, private router: Router) { }

  sendPaymentRequest(payment: any) {
    let userId = JSON.parse(localStorage.getItem('userInfo')!).userId;
    return this.http.post(this.baseURL + this.mainURL + userId + '/sendPaymentRequest', payment, { responseType: 'text' });
  }

  getProduct(productKey: string) {
    return this.http.get(`assets/${environment.projectName}/content/common/products.json`).toPromise().then((products: any) => {
      return products.find((product: any) => product.name === productKey);
    });
  }

  // getProduct(productKey: string) {
  //   return this.http.get(this.baseURL + this.mainURL + 'getProduct/' + productKey);
  // }

  getProducts() {
    return this.http.get(this.baseURL + this.mainURL + 'getProducts');
  }

  getPayments() {
    return this.http.get(this.baseURL + this.mainURL + 'getPayments');
  }

  setProducts() {
    this.http.get(`assets/${environment.projectName}/content/common/products.json`).subscribe((res: any) => {
      return this.http.post(this.baseURL + this.mainURL + 'setProducts', res).subscribe((res) => {
        console.log(res);
      });
    })
  }

  checkIsProductPurchased(productName: string): Promise<boolean> {
    let userId = JSON.parse(localStorage.getItem('userInfo')!).userId;
    return new Promise((resolve, reject) => {
      this.http.post(this.baseURL + this.mainURL + userId + '/checkProductStatus', productName).subscribe((isPurchased) => {
        if (isPurchased) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, (error) => {
        reject(error);
      });
    });
  }
}
